import { fetchSpecialMailFoldersProject } from '../projects/specialMailFolder';
import { fetchSpecialMailFoldersMe } from '../me/specialMailFoldersMe';

export const fetchSpecialMailFolders = (projectId: string) => {
  if (projectId === 'me') {
    return fetchSpecialMailFoldersMe();
  }
  return fetchSpecialMailFoldersProject(projectId);
};
